import { useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"
import { startLoading, stopLoading } from "utils/loaderBus"

// Gives a brief loader flash on every nav (sidebar/menu clicks, programmatic
// navigate() calls). Skips the very first render so it doesn't flash on
// initial page load. Most destination pages also fire their own axios calls
// on mount, which share the same loaderBus counter, so this blends into
// that rather than causing a separate flicker.
export default function RouteChangeLoader() {
  const location = useLocation()
  const isFirstRender = useRef(true)

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }
    startLoading()
    const timer = setTimeout(stopLoading, 300)
    // If pathname changes again before the timer fires (e.g. /logout
    // immediately redirecting to /login), clearing the timeout alone would
    // cancel the pending stopLoading() and leak the counter - stopLoading()
    // is idempotent (clamped at 0), so calling it here too keeps every
    // startLoading() balanced no matter how fast navigations chain.
    return () => {
      clearTimeout(timer)
      stopLoading()
    }
  }, [location.pathname])

  return null
}
